<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{ 'incidents.cardTitle' | t }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'selectExportTypeBelow' | t }}</h6>
        <hr />
        @if (awaitingDownload) {
            <div class="fancy-loader submodule sm"></div>
        } @else {
            <button class="btn btn-default me-2 mb-2" (click)="download()">
                {{ 'incidents.incidentsOverviewButton' | t }}
            </button>
        }
    </div>
</div>
